export default __webpack_public_path__ + "static/media/Globe.171663c8.svg";